// Yofis — контракт API `yofis.v1`. Стрим событий (ADR-010).
//
// Сервер хранит журнал событий узла с TTL (`NodeSettings.event_journal_ttl_days`, по умолчанию 7 дней).
// `Subscribe(cursor)` отдаёт всё после курсора, затем — живой поток. Пустой курсор — только живой поток
// (клиент сам делает полную загрузку). Порядок событий монотонный по курсору; пропущенных событий нет
// по построению. Разрыв — клиент переподключается с backoff (1 с → 30 с, jitter) и последним курсором.
// `TypingUpdated` и `PresenceUpdated` в журнал не попадают — только живые. Курсор устарел → `ResyncRequired`
// (или ошибка CURSOR_EXPIRED при подписке): клиент делает `ListChats` + `GetMessages(latest)`.

// @generated by protoc-gen-es v2.15.0 with parameter "target=ts,import_extension=ts"
// @generated from file yofis/v1/event.proto (package yofis.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Room } from "./call_pb.ts";
import { file_yofis_v1_call } from "./call_pb.ts";
import type { Chat, Member } from "./chat_pb.ts";
import { file_yofis_v1_chat } from "./chat_pb.ts";
import type { Device, Presence, User } from "./common_pb.ts";
import { file_yofis_v1_common } from "./common_pb.ts";
import type { Link } from "./link_pb.ts";
import { file_yofis_v1_link } from "./link_pb.ts";
import type { Message as Message$1, Reaction } from "./message_pb.ts";
import { file_yofis_v1_message } from "./message_pb.ts";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file yofis/v1/event.proto.
 */
export const file_yofis_v1_event: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_yofis_v1_call, file_yofis_v1_chat, file_yofis_v1_common, file_yofis_v1_link, file_yofis_v1_message]);

/**
 * Подписка на события.
 *
 * @generated from message yofis.v1.SubscribeRequest
 */
export type SubscribeRequest = Message<"yofis.v1.SubscribeRequest"> & {
  /**
   * Курсор последнего обработанного события; пусто — только живой поток.
   *
   * @generated from field: string cursor = 1;
   */
  cursor: string;
};

/**
 * Describes the message yofis.v1.SubscribeRequest.
 * Use `create(SubscribeRequestSchema)` to create a new message.
 */
export const SubscribeRequestSchema: GenMessage<SubscribeRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_event, 0);

/**
 * Один элемент стрима.
 *
 * @generated from message yofis.v1.SubscribeResponse
 */
export type SubscribeResponse = Message<"yofis.v1.SubscribeResponse"> & {
  /**
   * Событие.
   *
   * @generated from field: yofis.v1.Event event = 1;
   */
  event?: Event | undefined;
};

/**
 * Describes the message yofis.v1.SubscribeResponse.
 * Use `create(SubscribeResponseSchema)` to create a new message.
 */
export const SubscribeResponseSchema: GenMessage<SubscribeResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_event, 1);

/**
 * Событие узла.
 *
 * @generated from message yofis.v1.Event
 */
export type Event = Message<"yofis.v1.Event"> & {
  /**
   * Курсор события: сохранить после обработки, передать при переподключении.
   *
   * @generated from field: string cursor = 1;
   */
  cursor: string;

  /**
   * Когда произошло.
   *
   * @generated from field: google.protobuf.Timestamp at = 2;
   */
  at?: Timestamp | undefined;

  /**
   * Содержимое; неизвестный клиенту тип — пропустить, курсор сохранить.
   *
   * @generated from oneof yofis.v1.Event.payload
   */
  payload: {
    /**
     * Новое сообщение.
     *
     * @generated from field: yofis.v1.MessageNew message_new = 10;
     */
    value: MessageNew;
    case: "messageNew";
  } | {
    /**
     * Сообщение изменено (текст, реакции не сюда, live-геолокация, опрос, закреп).
     *
     * @generated from field: yofis.v1.MessageEdited message_edited = 11;
     */
    value: MessageEdited;
    case: "messageEdited";
  } | {
    /**
     * Сообщение удалено.
     *
     * @generated from field: yofis.v1.MessageDeleted message_deleted = 12;
     */
    value: MessageDeleted;
    case: "messageDeleted";
  } | {
    /**
     * Реакции обновлены.
     *
     * @generated from field: yofis.v1.ReactionsUpdated reactions_updated = 13;
     */
    value: ReactionsUpdated;
    case: "reactionsUpdated";
  } | {
    /**
     * Отметка прочтения (моя с другого устройства или чужая).
     *
     * @generated from field: yofis.v1.ReadUpdated read_updated = 14;
     */
    value: ReadUpdated;
    case: "readUpdated";
  } | {
    /**
     * Кто-то печатает (не журналируется).
     *
     * @generated from field: yofis.v1.TypingUpdated typing_updated = 15;
     */
    value: TypingUpdated;
    case: "typingUpdated";
  } | {
    /**
     * Присутствие изменилось (не журналируется).
     *
     * @generated from field: yofis.v1.PresenceUpdated presence_updated = 16;
     */
    value: PresenceUpdated;
    case: "presenceUpdated";
  } | {
    /**
     * Чат создан, изменён или изменились мои настройки чата.
     *
     * @generated from field: yofis.v1.ChatUpdated chat_updated = 17;
     */
    value: ChatUpdated;
    case: "chatUpdated";
  } | {
    /**
     * Чат пропал из моего списка.
     *
     * @generated from field: yofis.v1.ChatRemoved chat_removed = 18;
     */
    value: ChatRemoved;
    case: "chatRemoved";
  } | {
    /**
     * Участник добавлен, удалён или сменил роль.
     *
     * @generated from field: yofis.v1.MemberUpdated member_updated = 19;
     */
    value: MemberUpdated;
    case: "memberUpdated";
  } | {
    /**
     * Ссылка-право выпущена, изменилась или отозвана.
     *
     * @generated from field: yofis.v1.LinkUpdated link_updated = 20;
     */
    value: LinkUpdated;
    case: "linkUpdated";
  } | {
    /**
     * Изменение состояния заявки в лобби (моей — как заявителя, или в моём чате — как администратора).
     *
     * @generated from field: yofis.v1.LobbyUpdated lobby_updated = 21;
     */
    value: LobbyUpdated;
    case: "lobbyUpdated";
  } | {
    /**
     * Комната звонка создана, изменилась или завершена (v1.5).
     *
     * @generated from field: yofis.v1.RoomUpdated room_updated = 22;
     */
    value: RoomUpdated;
    case: "roomUpdated";
  } | {
    /**
     * Устройство отозвано; если это текущее — клиент разлогинивается.
     *
     * @generated from field: yofis.v1.DeviceRevoked device_revoked = 23;
     */
    value: DeviceRevoked;
    case: "deviceRevoked";
  } | {
    /**
     * Сессия отозвана — клиент разлогинивается.
     *
     * @generated from field: yofis.v1.SessionRevoked session_revoked = 24;
     */
    value: SessionRevoked;
    case: "sessionRevoked";
  } | {
    /**
     * Курсор устарел — нужен полный ресинк.
     *
     * @generated from field: yofis.v1.ResyncRequired resync_required = 25;
     */
    value: ResyncRequired;
    case: "resyncRequired";
  } | {
    /**
     * Пульс сервера с интервалом `NodeInfo.heartbeat_seconds` (10–55, по умолчанию 25);
     * клиент считает связь потерянной после двух пропущенных подряд.
     *
     * @generated from field: yofis.v1.Heartbeat heartbeat = 26;
     */
    value: Heartbeat;
    case: "heartbeat";
  } | {
    /**
     * Вход, на который стоит посмотреть: незнакомое устройство или вход по ссылке (0.16, ADR-036).
     *
     * @generated from field: yofis.v1.UnfamiliarSignIn unfamiliar_sign_in = 27;
     */
    value: UnfamiliarSignIn;
    case: "unfamiliarSignIn";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message yofis.v1.Event.
 * Use `create(EventSchema)` to create a new message.
 */
export const EventSchema: GenMessage<Event> = /*@__PURE__*/
  messageDesc(file_yofis_v1_event, 2);

/**
 * Новое сообщение.
 *
 * @generated from message yofis.v1.MessageNew
 */
export type MessageNew = Message<"yofis.v1.MessageNew"> & {
  /**
   * Сообщение.
   *
   * @generated from field: yofis.v1.Message message = 1;
   */
  message?: Message$1 | undefined;
};

/**
 * Describes the message yofis.v1.MessageNew.
 * Use `create(MessageNewSchema)` to create a new message.
 */
export const MessageNewSchema: GenMessage<MessageNew> = /*@__PURE__*/
  messageDesc(file_yofis_v1_event, 3);

/**
 * Сообщение изменено.
 *
 * @generated from message yofis.v1.MessageEdited
 */
export type MessageEdited = Message<"yofis.v1.MessageEdited"> & {
  /**
   * Сообщение целиком после изменения.
   *
   * @generated from field: yofis.v1.Message message = 1;
   */
  message?: Message$1 | undefined;
};

/**
 * Describes the message yofis.v1.MessageEdited.
 * Use `create(MessageEditedSchema)` to create a new message.
 */
export const MessageEditedSchema: GenMessage<MessageEdited> = /*@__PURE__*/
  messageDesc(file_yofis_v1_event, 4);

/**
 * Сообщение удалено.
 *
 * @generated from message yofis.v1.MessageDeleted
 */
export type MessageDeleted = Message<"yofis.v1.MessageDeleted"> & {
  /**
   * Чат.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * Сообщение.
   *
   * @generated from field: string message_id = 2;
   */
  messageId: string;

  /**
   * Удалено у всех (иначе — только у меня, с другого устройства).
   *
   * @generated from field: bool for_everyone = 3;
   */
  forEveryone: boolean;
};

/**
 * Describes the message yofis.v1.MessageDeleted.
 * Use `create(MessageDeletedSchema)` to create a new message.
 */
export const MessageDeletedSchema: GenMessage<MessageDeleted> = /*@__PURE__*/
  messageDesc(file_yofis_v1_event, 5);

/**
 * Реакции обновлены.
 *
 * @generated from message yofis.v1.ReactionsUpdated
 */
export type ReactionsUpdated = Message<"yofis.v1.ReactionsUpdated"> & {
  /**
   * Чат.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * Сообщение.
   *
   * @generated from field: string message_id = 2;
   */
  messageId: string;

  /**
   * Полный набор реакций после изменения.
   *
   * @generated from field: repeated yofis.v1.Reaction reactions = 3;
   */
  reactions: Reaction[];
};

/**
 * Describes the message yofis.v1.ReactionsUpdated.
 * Use `create(ReactionsUpdatedSchema)` to create a new message.
 */
export const ReactionsUpdatedSchema: GenMessage<ReactionsUpdated> = /*@__PURE__*/
  messageDesc(file_yofis_v1_event, 6);

/**
 * Отметка прочтения обновлена.
 *
 * @generated from message yofis.v1.ReadUpdated
 */
export type ReadUpdated = Message<"yofis.v1.ReadUpdated"> & {
  /**
   * Чат.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * Чья отметка.
   *
   * @generated from field: string address = 2;
   */
  address: string;

  /**
   * Последнее прочитанное сообщение.
   *
   * @generated from field: string last_read_message_id = 3;
   */
  lastReadMessageId: string;
};

/**
 * Describes the message yofis.v1.ReadUpdated.
 * Use `create(ReadUpdatedSchema)` to create a new message.
 */
export const ReadUpdatedSchema: GenMessage<ReadUpdated> = /*@__PURE__*/
  messageDesc(file_yofis_v1_event, 7);

/**
 * Кто-то печатает.
 *
 * @generated from message yofis.v1.TypingUpdated
 */
export type TypingUpdated = Message<"yofis.v1.TypingUpdated"> & {
  /**
   * Чат.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * Кто.
   *
   * @generated from field: string address = 2;
   */
  address: string;

  /**
   * До какого момента считать, что печатает (сервер гасит через 6 с).
   *
   * @generated from field: google.protobuf.Timestamp until = 3;
   */
  until?: Timestamp | undefined;
};

/**
 * Describes the message yofis.v1.TypingUpdated.
 * Use `create(TypingUpdatedSchema)` to create a new message.
 */
export const TypingUpdatedSchema: GenMessage<TypingUpdated> = /*@__PURE__*/
  messageDesc(file_yofis_v1_event, 8);

/**
 * Присутствие изменилось.
 *
 * @generated from message yofis.v1.PresenceUpdated
 */
export type PresenceUpdated = Message<"yofis.v1.PresenceUpdated"> & {
  /**
   * Чьё.
   *
   * @generated from field: string address = 1;
   */
  address: string;

  /**
   * Новое присутствие.
   *
   * @generated from field: yofis.v1.Presence presence = 2;
   */
  presence?: Presence | undefined;
};

/**
 * Describes the message yofis.v1.PresenceUpdated.
 * Use `create(PresenceUpdatedSchema)` to create a new message.
 */
export const PresenceUpdatedSchema: GenMessage<PresenceUpdated> = /*@__PURE__*/
  messageDesc(file_yofis_v1_event, 9);

/**
 * Чат создан или изменён.
 *
 * @generated from message yofis.v1.ChatUpdated
 */
export type ChatUpdated = Message<"yofis.v1.ChatUpdated"> & {
  /**
   * Чат целиком.
   *
   * @generated from field: yofis.v1.Chat chat = 1;
   */
  chat?: Chat | undefined;
};

/**
 * Describes the message yofis.v1.ChatUpdated.
 * Use `create(ChatUpdatedSchema)` to create a new message.
 */
export const ChatUpdatedSchema: GenMessage<ChatUpdated> = /*@__PURE__*/
  messageDesc(file_yofis_v1_event, 10);

/**
 * Чат пропал из моего списка.
 *
 * @generated from message yofis.v1.ChatRemoved
 */
export type ChatRemoved = Message<"yofis.v1.ChatRemoved"> & {
  /**
   * Чат.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * Почему.
   *
   * @generated from field: yofis.v1.ChatRemovedReason reason = 2;
   */
  reason: ChatRemovedReason;
};

/**
 * Describes the message yofis.v1.ChatRemoved.
 * Use `create(ChatRemovedSchema)` to create a new message.
 */
export const ChatRemovedSchema: GenMessage<ChatRemoved> = /*@__PURE__*/
  messageDesc(file_yofis_v1_event, 11);

/**
 * Участник изменился.
 *
 * @generated from message yofis.v1.MemberUpdated
 */
export type MemberUpdated = Message<"yofis.v1.MemberUpdated"> & {
  /**
   * Чат.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * Участник после изменения.
   *
   * @generated from field: yofis.v1.Member member = 2;
   */
  member?: Member | undefined;

  /**
   * Что произошло.
   *
   * @generated from field: yofis.v1.MemberChange change = 3;
   */
  change: MemberChange;
};

/**
 * Describes the message yofis.v1.MemberUpdated.
 * Use `create(MemberUpdatedSchema)` to create a new message.
 */
export const MemberUpdatedSchema: GenMessage<MemberUpdated> = /*@__PURE__*/
  messageDesc(file_yofis_v1_event, 12);

/**
 * Ссылка-право изменилась.
 *
 * @generated from message yofis.v1.LinkUpdated
 */
export type LinkUpdated = Message<"yofis.v1.LinkUpdated"> & {
  /**
   * Ссылка целиком.
   *
   * @generated from field: yofis.v1.Link link = 1;
   */
  link?: Link | undefined;
};

/**
 * Describes the message yofis.v1.LinkUpdated.
 * Use `create(LinkUpdatedSchema)` to create a new message.
 */
export const LinkUpdatedSchema: GenMessage<LinkUpdated> = /*@__PURE__*/
  messageDesc(file_yofis_v1_event, 13);

/**
 * Заявка в лобби изменилась.
 *
 * @generated from message yofis.v1.LobbyUpdated
 */
export type LobbyUpdated = Message<"yofis.v1.LobbyUpdated"> & {
  /**
   * Чат или комната.
   *
   * @generated from field: string target_id = 1;
   */
  targetId: string;

  /**
   * Заявитель.
   *
   * @generated from field: yofis.v1.User user = 2;
   */
  user?: User | undefined;

  /**
   * Состояние.
   *
   * @generated from field: yofis.v1.LobbyState state = 3;
   */
  state: LobbyState;
};

/**
 * Describes the message yofis.v1.LobbyUpdated.
 * Use `create(LobbyUpdatedSchema)` to create a new message.
 */
export const LobbyUpdatedSchema: GenMessage<LobbyUpdated> = /*@__PURE__*/
  messageDesc(file_yofis_v1_event, 14);

/**
 * Вход, на который стоит посмотреть (0.16, ADR-036).
 *
 * Поднимается **не на каждую сессию**: только на незнакомом устройстве или при входе по ссылке.
 * Уведомление, приходящее на каждое обычное действие, отключают через неделю — и вместе с ним
 * отключают настоящее. Событие журналируемое: оно нужно ровно тогда, когда человека не было
 * в сети, и пропасть не должно.
 *
 * @generated from message yofis.v1.UnfamiliarSignIn
 */
export type UnfamiliarSignIn = Message<"yofis.v1.UnfamiliarSignIn"> & {
  /**
   * Устройство, с которого вошли: по нему человек отзывает доступ, если это был не он.
   *
   * @generated from field: yofis.v1.Device device = 1;
   */
  device?: Device | undefined;

  /**
   * Когда.
   *
   * @generated from field: google.protobuf.Timestamp at = 2;
   */
  at?: Timestamp | undefined;

  /**
   * Как вошли: пароль, ссылка, OIDC — человеку это говорит больше, чем время.
   *
   * @generated from field: yofis.v1.SignInMethod method = 3;
   */
  method: SignInMethod;
};

/**
 * Describes the message yofis.v1.UnfamiliarSignIn.
 * Use `create(UnfamiliarSignInSchema)` to create a new message.
 */
export const UnfamiliarSignInSchema: GenMessage<UnfamiliarSignIn> = /*@__PURE__*/
  messageDesc(file_yofis_v1_event, 15);

/**
 * Комната звонка изменилась (v1.5).
 *
 * @generated from message yofis.v1.RoomUpdated
 */
export type RoomUpdated = Message<"yofis.v1.RoomUpdated"> & {
  /**
   * Комната целиком.
   *
   * @generated from field: yofis.v1.Room room = 1;
   */
  room?: Room | undefined;
};

/**
 * Describes the message yofis.v1.RoomUpdated.
 * Use `create(RoomUpdatedSchema)` to create a new message.
 */
export const RoomUpdatedSchema: GenMessage<RoomUpdated> = /*@__PURE__*/
  messageDesc(file_yofis_v1_event, 16);

/**
 * Устройство отозвано.
 *
 * @generated from message yofis.v1.DeviceRevoked
 */
export type DeviceRevoked = Message<"yofis.v1.DeviceRevoked"> & {
  /**
   * Какое устройство.
   *
   * @generated from field: string device_id = 1;
   */
  deviceId: string;
};

/**
 * Describes the message yofis.v1.DeviceRevoked.
 * Use `create(DeviceRevokedSchema)` to create a new message.
 */
export const DeviceRevokedSchema: GenMessage<DeviceRevoked> = /*@__PURE__*/
  messageDesc(file_yofis_v1_event, 17);

/**
 * Сессия отозвана; полей нет.
 *
 * @generated from message yofis.v1.SessionRevoked
 */
export type SessionRevoked = Message<"yofis.v1.SessionRevoked"> & {
};

/**
 * Describes the message yofis.v1.SessionRevoked.
 * Use `create(SessionRevokedSchema)` to create a new message.
 */
export const SessionRevokedSchema: GenMessage<SessionRevoked> = /*@__PURE__*/
  messageDesc(file_yofis_v1_event, 18);

/**
 * Курсор устарел — нужен полный ресинк; полей нет.
 *
 * @generated from message yofis.v1.ResyncRequired
 */
export type ResyncRequired = Message<"yofis.v1.ResyncRequired"> & {
};

/**
 * Describes the message yofis.v1.ResyncRequired.
 * Use `create(ResyncRequiredSchema)` to create a new message.
 */
export const ResyncRequiredSchema: GenMessage<ResyncRequired> = /*@__PURE__*/
  messageDesc(file_yofis_v1_event, 19);

/**
 * Пульс; полей нет.
 *
 * @generated from message yofis.v1.Heartbeat
 */
export type Heartbeat = Message<"yofis.v1.Heartbeat"> & {
};

/**
 * Describes the message yofis.v1.Heartbeat.
 * Use `create(HeartbeatSchema)` to create a new message.
 */
export const HeartbeatSchema: GenMessage<Heartbeat> = /*@__PURE__*/
  messageDesc(file_yofis_v1_event, 20);

/**
 * Причина исчезновения чата.
 *
 * @generated from enum yofis.v1.ChatRemovedReason
 */
export enum ChatRemovedReason {
  /**
   * Не задана.
   *
   * @generated from enum value: CHAT_REMOVED_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Я вышел (с другого устройства).
   *
   * @generated from enum value: CHAT_REMOVED_REASON_LEFT = 1;
   */
  LEFT = 1,

  /**
   * Меня удалили.
   *
   * @generated from enum value: CHAT_REMOVED_REASON_REMOVED = 2;
   */
  REMOVED = 2,

  /**
   * Чат удалён владельцем.
   *
   * @generated from enum value: CHAT_REMOVED_REASON_DELETED = 3;
   */
  DELETED = 3,
}

/**
 * Describes the enum yofis.v1.ChatRemovedReason.
 */
export const ChatRemovedReasonSchema: GenEnum<ChatRemovedReason> = /*@__PURE__*/
  enumDesc(file_yofis_v1_event, 0);

/**
 * Что произошло с участником.
 *
 * @generated from enum yofis.v1.MemberChange
 */
export enum MemberChange {
  /**
   * Не задано.
   *
   * @generated from enum value: MEMBER_CHANGE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Добавлен или вошёл.
   *
   * @generated from enum value: MEMBER_CHANGE_ADDED = 1;
   */
  ADDED = 1,

  /**
   * Удалён или вышел.
   *
   * @generated from enum value: MEMBER_CHANGE_REMOVED = 2;
   */
  REMOVED = 2,

  /**
   * Сменилась роль.
   *
   * @generated from enum value: MEMBER_CHANGE_ROLE = 3;
   */
  ROLE = 3,
}

/**
 * Describes the enum yofis.v1.MemberChange.
 */
export const MemberChangeSchema: GenEnum<MemberChange> = /*@__PURE__*/
  enumDesc(file_yofis_v1_event, 1);

/**
 * Состояние заявки в лобби.
 *
 * @generated from enum yofis.v1.LobbyState
 */
export enum LobbyState {
  /**
   * Не задано.
   *
   * @generated from enum value: LOBBY_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Ожидает решения.
   *
   * @generated from enum value: LOBBY_STATE_PENDING = 1;
   */
  PENDING = 1,

  /**
   * Впущен.
   *
   * @generated from enum value: LOBBY_STATE_ADMITTED = 2;
   */
  ADMITTED = 2,

  /**
   * Отклонён.
   *
   * @generated from enum value: LOBBY_STATE_REJECTED = 3;
   */
  REJECTED = 3,
}

/**
 * Describes the enum yofis.v1.LobbyState.
 */
export const LobbyStateSchema: GenEnum<LobbyState> = /*@__PURE__*/
  enumDesc(file_yofis_v1_event, 2);

/**
 * Способ входа (0.16). Передаётся тем, кто вход выполнил, а не выводится из состояния учётной
 * записи: один ответ на разные события неразличим в журнале и в уведомлении человеку.
 *
 * @generated from enum yofis.v1.SignInMethod
 */
export enum SignInMethod {
  /**
   * Не задан (старый клиент или запись до 0.16).
   *
   * @generated from enum value: SIGN_IN_METHOD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Логин и пароль.
   *
   * @generated from enum value: SIGN_IN_METHOD_PASSWORD = 1;
   */
  PASSWORD = 1,

  /**
   * Ссылка входа (`LoginWithLink`, `RegisterByInvite`): предъявительская, поэтому событие поднимается
   * всегда, а не только на новом устройстве.
   *
   * @generated from enum value: SIGN_IN_METHOD_LINK = 2;
   */
  LINK = 2,

  /**
   * Внешний провайдер (OIDC).
   *
   * @generated from enum value: SIGN_IN_METHOD_OIDC = 3;
   */
  OIDC = 3,

  /**
   * Внешний участник встречи (`JoinAsGuest`): учётной записи нет, уведомлять некого.
   *
   * @generated from enum value: SIGN_IN_METHOD_GUEST = 4;
   */
  GUEST = 4,
}

/**
 * Describes the enum yofis.v1.SignInMethod.
 */
export const SignInMethodSchema: GenEnum<SignInMethod> = /*@__PURE__*/
  enumDesc(file_yofis_v1_event, 3);

/**
 * Серверный стрим событий. Уровень — signed при открытии.
 *
 * Подпись (§2 документа 12, 0.5): подписывается тело **первого (единственного) сообщения запроса**, которое клиент
 * отправляет сразу при открытии потока; окно ±300 с и уникальность nonce — как у unary. Переподключение — новая
 * подпись с новым nonce. Ответный поток не подписывается.
 *
 * @generated from service yofis.v1.EventService
 */
export const EventService: GenService<{
  /**
   * Подписаться на события после курсора; сервер шлёт `Heartbeat` с интервалом `NodeInfo.heartbeat_seconds`.
   * Уровень: signed. Ошибки: CURSOR_EXPIRED.
   *
   * @generated from rpc yofis.v1.EventService.Subscribe
   */
  subscribe: {
    methodKind: "server_streaming";
    input: typeof SubscribeRequestSchema;
    output: typeof SubscribeResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_yofis_v1_event, 0);

